module.exports = __webpack_public_path__ + "static/media/sound4.ab7cafce.mp3";